import api from "../../index"

const wealthPartnerReferralsApi = api.injectEndpoints({
  endpoints: (build) => ({
    inviteInvestor: build.mutation({
      query: (params) => ({
        url: `/wealthPartner/referrals`,
        method: "POST",
        body: params,
      }),
    }),
    getReferrals: build.query({
      query: (params) => ({
        url: `/wealthPartner/referrals`,
        method: "GET",
        params,
      }),
    }),
    reInviteReferal: build.mutation({
      query: ({ id }) => ({
        url: `/wealthPartner/referrals/${id}/re-invite`,
        method: "PUT",
      }),
    }),
    getReferal: build.query({
      query: ({ id }) => ({
        url: `/wealthPartner/referrals/${id}`,
        method: "GET",
      }),
    }),
    getSignDocumentsWp: build.query({
      query: () => ({
        url: `/wealthPartner/referrals/signed-documents`,
        method: "GET",
      }),
    }),
    updateReferal: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/referrals/${id}`,
        method: "POST",
        body,
      }),
    }),
    getAssignedInvestorsList: build.query({
      query: () => ({
        url: `/wealthPartner/referrals/assigned/investors`,
        method: "GET",
      }),
    }),
    icdSignNewAgreementWp: build.mutation({
      query: (body) => ({
        url: `/wealthPartner/referrals/sign/agreement`,
        method: "POST",
        body,
      }),
    }),
  }),
})

export const {
  useInviteInvestorMutation,
  useLazyGetReferralsQuery,
  useReInviteReferalMutation,
  useLazyGetReferalQuery,
  useUpdateReferalMutation,
  useLazyGetSignDocumentsWpQuery,
  useLazyGetAssignedInvestorsListQuery,
  useGetAssignedInvestorsListQuery,
  useIcdSignNewAgreementWpMutation,
} = wealthPartnerReferralsApi
